import * as yup from "yup";

export const OFFICE_EDIT_FORM_SCHEMA = yup.object().shape({
  name: yup.string().required("Molimo Vas da unesete naziv"),
});
